<template>
  <div class="condition-edit">
		<component 
			:is="componentName"
			:date-label="title"
			ref="componentRef"
			:dimension="dimension"
			:default-data="dimension.modalData"
			:load-data="(params)=>handleLoadData(params)"
			:loading="loading"
			:list.sync="list"
			:batchSelectData="batchSelectData"
			@disable-date="getDisableDate"
			:allData.sync="allData"
		/>
		<div class="tac mt20">
			<el-button type="default"  class="action-btn mr20" @click="$emit('close')">取消</el-button>
			<el-button type="primary"  class="action-btn ml20" @click="handleOnSubmit">确认</el-button>
		</div>
  </div>
</template>

<script>
import ContentType from './contentType.vue'
import DateType from './dateType.vue'
import ContentDimensionType from './contentDimensionType.vue'
import DateDimensionType from './dateDimensionType.vue'
import { DIMENSION_TYPE, CONDITION_CONTENT_DIMENSION_FORM } from '../../constant'
import { getMaterialConditionListApi } from '@/api'
import { batchSelectModal } from '@/components/modal'
export default {
    props: [ 'title' , 'dimension','conditionParams', 'range_time','cbs', 'defaultParams'],
    name: 'ConditionEditModal',
    components: { ContentType, DateType },
	data() {
		return {
			list: [],
			loading: false,
			allData: false,
			dataId: 0
		}
	},
    computed: {
		modalType() {
			return this.dimension.config.type
		},
		componentName() {
			const name = this.dimension.name;
			switch (true) {
				case CONDITION_CONTENT_DIMENSION_FORM.includes(name):
					return ContentDimensionType;
				case DIMENSION_TYPE.CONTENT===this.modalType:
					return ContentType;
				case DIMENSION_TYPE.DATE===this.modalType:
					return DateType;
				case DIMENSION_TYPE.DATE_SELECT===this.modalType:
					return DateDimensionType;
				default:
					return null;
			}
		}
      
    },
	methods: {
		batchSelectData(cbList) {
			const onSubmit = async (batch_list, callback)=> {
				const { exclude_condition_fields, condition } = this.conditionParams;
				if (!(batch_list && batch_list.length)) {
					callback()
					vm.close()
					return;
				}
				const params = {
					...this.defaultParams,
					return_condition: this.dimension.name,
					exclude_condition_fields,
					condition,
					range_time: this.range_time,
					batch_search: batch_list,
				};
				const { data } = await getMaterialConditionListApi(params);
				const { err_list, list } = data;
				const display_name = this.dimension.display_name;
				if (err_list.length) {
					delErrList({
						tip: `未找到以下${display_name}，请核实，是否需要剔除未找到的${display_name}?`,
						list: err_list,
						onOk() {
							cbList(list);
							vm.close()
						},
						colse() {}
					})
				}else {
					cbList(list);
					vm.close()
				}
				callback()
			}
			const { vm, delErrList } = batchSelectModal({
				title: `批量选择${this.dimension.display_name}`,
				props: {
					tip: `输入或粘贴${this.dimension.display_name}，每行一个`,
					hasLoading: true
				},
				cbs: {
					onSubmit
				}
			})
		},
		// 加载动态数据
		async handleLoadData(defaultParams = {}) {
			try {
				this.loading = true
				const { exclude_condition_fields, condition } = this.conditionParams;
				const isPage = this.dimension.config.page
				const params = {
					...this.defaultParams,
					return_condition: this.dimension.name,//位置重要
					...defaultParams,
					exclude_condition_fields,
					condition,
					range_time: this.range_time,
				};
				if (isPage) {
					const lastData = this.list[this.list.length - 1];
					params.last = lastData ? lastData.id: null
				};
				const dataId = this.dataId = Date.now()
				const { data } = await getMaterialConditionListApi(params);
				if (dataId !== this.dataId) {
					return;
				}
				if (data.list.length < 20) {
					this.allData = true
				};
				this.list = this.list.concat(data.list);
				this.loading = false;
			} catch (error) {
				this.loading = false;
				this.$message.error(error.info || error.message)
			}
		},
		async handleOnSubmit() {
			const formData = await this.$refs.componentRef.getFormData();
			this.cbs.onSubmit(formData,  formData.list?.length ===0);
		},
		async getDisableDate(callback, defaultParams) {
			try {
				this.loading = true;
				const { exclude_condition_fields, condition } = this.conditionParams;
				const params = {
					...this.defaultParams,
					return_condition: this.dimension.name,//位置重要
					...defaultParams,
					exclude_condition_fields,
					condition,
					range_time: this.range_time,
				};
				const { data } = await getMaterialConditionListApi(params);
				callback(data.list)
			} catch (error) {}finally {
				this.loading = false;
			}
		}
	}

}
</script>

<style lang="scss" scoped>

</style>